
import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import BangHopDong from "./BangHopDong";
import ModalThemNhieuHopDong from "./ModalThemNhieuHopDong";
import ModalXuatHopDong from "./ModalXuatHopDong";

export default function DanhSachHopDong() {
  const [showMulti, setShowMulti] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selected, setSelected] = useState([]);

  // useCallback: BangHopDong gọi onSelectChange trong useEffect, hàm mới mỗi render sẽ gây lặp.
  const handleSelectChange = useCallback((items) => setSelected(items), []);

  const removeSelected = (id) => setSelected((current) => current.filter((i) => i.id !== id));

  return (<AkkhorLayout idrole="dashboard">
    <div className="breadcrumbs-area">
      <ul>
        <li>
          <Link to="/">Trang chủ</Link>
        </li>
        <li>
          Danh sách hợp đồng
        </li>
      </ul>
    </div>

    <div className="card height-auto">
      <div className="card-body">
        <div className="heading-layout1">
          <div className="item-title">
            <h3>Danh sách Văn bản, Hợp đồng</h3>
          </div>
          <div className="d-flex">
            <button
              type="button"
              className="btn btn-info m-2"
              style={{ fontSize: 13, fontWeight: '600', color: "#FFF" }}
              onClick={() => setShowExport(true)}
              disabled={selected.length === 0}
            >
              <i className="fas fa-file-export"></i> Xem / Xuất file
              {selected.length > 0 ? " (" + selected.length + ")" : ""}
            </button>
            <button
              type="button"
              className="btn btn-warning m-2"
              style={{ fontSize: 13, fontWeight: '600' }}
              onClick={() => setShowMulti(true)}
            >
              <i className="fas fa-users"></i> Thêm nhiều hợp đồng
            </button>
            <Link
              to="/add-hop-dong"
              className="btn btn-success m-2"
              style={{ fontSize: 13, fontWeight: '600' }}>
              <i className="fas fa-plus"></i> Thêm mới
            </Link>
          </div>
        </div>

        <BangHopDong refresh={refresh} onSelectChange={handleSelectChange} />
      </div>
    </div>

    <ModalThemNhieuHopDong
      show={showMulti}
      onHide={() => setShowMulti(false)}
      onDone={() => setRefresh(!refresh)}
    />

    <ModalXuatHopDong
      show={showExport}
      onHide={() => setShowExport(false)}
      items={selected}
      onRemove={removeSelected}
    />
  </AkkhorLayout>);
}
